(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-banner"] && !Shopify.designMode) return;
  try {
    
  /* Two-line clamp with a toggle; the button only shows when the text overflows. */
  (() => {
    const init = () => {
      document.querySelectorAll('[data-read-more]').forEach((root) => {
        const body = root.querySelector('[data-read-more-body]');
        const toggle = root.querySelector('[data-read-more-toggle]');
        if (!body || !toggle || toggle.dataset.bound) return;
        toggle.dataset.bound = 'true';
        const overflows = body.scrollHeight > body.clientHeight + 1;
        toggle.hidden = !overflows;
        if (!overflows) body.classList.add('is-expanded');
        toggle.addEventListener('click', () => {
          const expanded = body.classList.toggle('is-expanded');
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
        });
      });
    };
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-expect"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-expect-tabs]').forEach((root) => {
    const rail = root.querySelector('[data-expect-rail]');
    const tabs = root.querySelectorAll('[data-expect-tab]');
    if (!rail || tabs.length === 0) return;
    const cards = Array.from(rail.children);
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const card = cards[Number(tab.dataset.expectTab)];
        if (card) rail.scrollTo({ left: card.offsetLeft - cards[0].offsetLeft, behavior: 'smooth' });
      });
    });
    rail.addEventListener(
      'scroll',
      () => {
        let active = 0;
        cards.forEach((card, i) => {
          const d = Math.abs(card.offsetLeft - cards[0].offsetLeft - rail.scrollLeft);
          const best = Math.abs(cards[active].offsetLeft - cards[0].offsetLeft - rail.scrollLeft);
          if (d < best) active = i;
        });
        tabs.forEach((tab, i) => tab.setAttribute('aria-selected', String(i === active)));
      },
      { passive: true }
    );
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-progress"] && !Shopify.designMode) return;
  try {
    
  /* Hydrogen's ProductProgress scroll fill: progress runs from the list's top
     reaching the viewport bottom to its bottom reaching the viewport centre;
     each connector fills by (progress * count - i), each dot fades in. */
  (() => {
    const clamp = (v) => Math.min(1, Math.max(0, v));
    const lists = () => document.querySelectorAll('[data-progress-steps]');
    let ticking = false;
    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      lists().forEach((list) => {
        const rect = list.getBoundingClientRect();
        const start = vh;
        const end = vh / 2 - rect.height;
        const progress = clamp((start - rect.top) / (start - end));
        const fills = list.querySelectorAll('[data-progress-fill]');
        const dots = list.querySelectorAll('[data-progress-dot]');
        const scaled = progress * dots.length;
        fills.forEach((el, i) => { el.style.transform = `scaleY(${clamp(scaled - i)})`; });
        dots.forEach((el, i) => { el.style.opacity = String(clamp((scaled - i) * 4 + 0.25)); });
      });
    };
    const request = () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    document.addEventListener('DOMContentLoaded', update);
    document.addEventListener('shopify:section:load', update);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  /* Below 1024px the reviews advance one slide every 5s (wrapping) while on
     screen — same behaviour as sections/testimonials.liquid. Touch, drag or
     wheel pauses it for 8s; reduced-motion visitors get a static carousel. */
  (() => {
    const INTERVAL = 5000;
    const RESUME_AFTER = 8000;
    const carousel = window.matchMedia('(max-width: 1023px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    const setup = (root) => {
      const rail = root.querySelector('[data-reviews-rail]');
      if (!rail || rail.dataset.bound) return;
      rail.dataset.bound = 'true';
      let visible = false;
      let pausedUntil = 0;

      const slides = () => [...rail.children].filter((s) => s.offsetWidth > 0 && s.querySelector('.at-review'));
      const current = () => {
        const centre = rail.scrollLeft + rail.clientWidth / 2;
        const list = slides();
        let best = 0;
        list.forEach((s, i) => {
          const d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - centre);
          const bd = Math.abs(list[best].offsetLeft + list[best].offsetWidth / 2 - centre);
          if (d < bd) best = i;
        });
        return best;
      };
      const goTo = (i) => {
        const s = slides()[i];
        if (s) rail.scrollTo({ left: s.offsetLeft - (rail.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
      };
      const pause = () => { pausedUntil = Date.now() + RESUME_AFTER; };

      ['pointerdown', 'touchstart', 'wheel'].forEach((e) => rail.addEventListener(e, pause, { passive: true }));
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }, { threshold: 0.4 }).observe(rail);

      setInterval(() => {
        if (!visible || !carousel.matches || reduced.matches || Date.now() < pausedUntil) return;
        const n = slides().length;
        if (n > 1) goTo((current() + 1) % n);
      }, INTERVAL);
    };

    const init = () => document.querySelectorAll('[data-reviews-carousel]').forEach(setup);
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-recommendations-wrapper]').forEach(function (wrapper) {
    var url = wrapper.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-recommendations-wrapper]');
        if (content && content.innerHTML.trim() !== '') {
          wrapper.innerHTML = content.innerHTML;
        }
      })
      .catch(function () {});
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  /* Below 1024px the reviews are a snap carousel that advances itself every
     5s (wrapping round) while it's on screen. Any touch, drag or wheel on the
     rail pauses it for 8s; reduced-motion visitors get a static carousel. */
  (() => {
    const INTERVAL = 5000;
    const RESUME_AFTER = 8000;
    const carousel = window.matchMedia('(max-width: 1023px)');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const setup = (root) => {
      const rail = root.querySelector('[data-testimonials-rail]');
      if (!rail || rail.dataset.bound) return;
      rail.dataset.bound = 'true';
      let visible = false;
      let pausedUntil = 0;
      const slides = () => [...rail.children];
      const current = () => {
        const centre = rail.scrollLeft + rail.clientWidth / 2;
        let best = 0;
        slides().forEach((s, i) => {
          const d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - centre);
          const bd = Math.abs(slides()[best].offsetLeft + slides()[best].offsetWidth / 2 - centre);
          if (d < bd) best = i;
        });
        return best;
      };
      const goTo = (i) => {
        const s = slides()[i];
        if (s) rail.scrollTo({ left: s.offsetLeft - (rail.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
      };
      const pause = () => { pausedUntil = Date.now() + RESUME_AFTER; };
      ['pointerdown', 'touchstart', 'wheel'].forEach((e) => rail.addEventListener(e, pause, { passive: true }));
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }, { threshold: 0.4 }).observe(rail);
      setInterval(() => {
        if (!visible || !carousel.matches || reduced.matches || Date.now() < pausedUntil) return;
        const n = slides().length;
        if (n > 1) goTo((current() + 1) % n);
      }, INTERVAL);
    };
    const init = () => document.querySelectorAll('[data-testimonials]').forEach(setup);
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-gallery"] && !Shopify.designMode) return;
  try {
    
  /* Hydrogen's UgcGallery playback: the first clip starts once the row is half
     visible; each clip hands off to the next when it ends (wrapping round);
     below 1024px the carousel scrolls to follow the playing clip. Clicking a
     clip pauses/resumes it or jumps to it, and the chain continues from there.
     Videos must not loop, or `ended` never fires. */
  (() => {
    const CAROUSEL = window.matchMedia('(max-width: 1023px)');
    const setup = (root) => {
      if (root.dataset.ugcBound) return;
      root.dataset.ugcBound = 'true';
      const rail = root.querySelector('.at-ugc-gallery-grid');
      const toggles = [...root.querySelectorAll('[data-ugc-toggle]')];
      const videos = toggles.map((t) => t.querySelector('video'));
      if (!rail || videos.some((v) => !v) || videos.length === 0) return;

      const follow = (i) => {
        if (!CAROUSEL.matches) return;
        const tile = toggles[i].closest('.shopify-block') || toggles[i];
        rail.scrollTo({ left: tile.offsetLeft - (rail.clientWidth - tile.offsetWidth) / 2, behavior: 'smooth' });
      };
      const play = (i) => {
        videos.forEach((v, j) => {
          if (j !== i && !v.paused) v.pause();
          toggles[j].classList.toggle('is-playing', j === i);
        });
        videos[i].play().catch(() => toggles[i].classList.remove('is-playing'));
        follow(i);
      };

      videos.forEach((video, i) => {
        video.loop = false;
        video.muted = true;
        video.addEventListener('ended', () => play((i + 1) % videos.length));
        toggles[i].addEventListener('click', () => {
          if (video.paused) {
            play(i);
          } else {
            video.pause();
            toggles[i].classList.remove('is-playing');
          }
        });
      });

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            play(0);
            observer.disconnect();
          }
        },
        { threshold: 0.5 }
      );
      observer.observe(root);
    };
    const init = () => document.querySelectorAll('[data-ugc-gallery]').forEach(setup);
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
